// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"ThirtyDaysNotice_modal-content_3XsBp"};